import { render, staticRenderFns } from "./productChnAndEng.vue?vue&type=template&id=046251d2"
import script from "./productChnAndEng.vue?vue&type=script&lang=js"
export * from "./productChnAndEng.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports